import { GridRowsProp } from '@mui/x-data-grid'
import { PrintOccurrenceSearchLog, PrintOccurrenceSearchLogRow } from '../interfaces'

 
export const mapUsersReportRows = (
  data: readonly PrintOccurrenceSearchLog[],
  page: number,
  pageSize: number,
): GridRowsProp => {
  return data.map((element: PrintOccurrenceSearchLog, index: number) => {
    const generatedId = element.id ?? page * pageSize + index + 1

  const registrationPrefix = element?.registration ? `[${element.registration}] ` : ''
    const normalizedUserName =
      element?.user_name || element?.representation_name || (typeof element?.users === 'string' ? element.users : '') || ''
    const normalizedRegistration = element?.registration || ''
    const normalizedDetail = element?.detail || ''
    const normalizedCreatedAt = element?.created_at || ''
    return {
      id: generatedId,
      ...element,
      user_name: normalizedUserName,
      registration: normalizedRegistration,
      detail: normalizedDetail,
      created_at: normalizedCreatedAt,
      'user:representation_name': `${registrationPrefix}${normalizedUserName}`,
      station: element?.station,
    } as PrintOccurrenceSearchLogRow
  })
}

